
<div class="app-body">
  <div class="layout-header">
    <app-hrm-header></app-hrm-header>
  </div>
  <div class="layout-main">
    <router-outlet></router-outlet>
  </div>
  <app-quick-launcher></app-quick-launcher>
</div>

